import React, { useState, useContext, useRef } from 'react';
import classNames from 'classnames';
import './CasinoGamesGrid.css';
import { AsgFwContext, AsgDictionaryContext } from '../../../contexts';
import { GridItem } from '../GridItem';
import { LoadMore } from '../../LoadMore';
import { GamesService } from '../../../../../shared/src/services/games.service';
import { useLiveCasinoState } from '../../../hooks/use-live-casino-state.hook';
import { useSelector, useDispatch } from 'react-redux';
import { useAsgActions } from '../../../../../shared/src/hooks/use-asg-actions.hook';
import { WinnersDesktopContainer } from '../../Winners/WinnersDesktopContainer';
import { useReadMoreGames } from '../../../hooks/use-read-more-games.hook';
import { useWinnersCalculateHook } from '../../../hooks/use-winners-calculate.hook';
import { verticalActionTypesEnum } from '../../../../../shared/src/enums/vertical-types.enum';
import { GridMessage } from '../GridMessage';
import { CasinoGamesGridContainer } from '../CasinoGamesGridContainer';
import { useApplySubcategoriesActionsToGames } from '../../../hooks/use-apply-subcategories-actions-to-games';

export const CasinoGamesGrid = ({
    gameIds = [],
    showWinners,
    currentSubcategoryAction,
}) => {
    const AsgFW = useContext(AsgFwContext);
    const Dictionary = useContext(AsgDictionaryContext);
    const [liveCasinoData, setLiveCasinoData] = useState(null);
    const maxAmountOfWinnersThumbnails = 3;
    const containerGridRef = useRef();
    const {
        session,
        balance: {
            Currency,
            CurrencySign,
        },
        recentGames,
    } = useSelector((state) => state.player);
    const {
        isMobile,
        regulation,
        verticalsById,
        currentVerticalId,
        areFavoritesEnabled
    } = useSelector((state) => state.app);
    const { jackpots, jackpotsByDateEndAsc } = useSelector((state) => state.jackpots);
    const { buyWin } = useSelector((state) => state.casino);
    const { favoriteGames } = useSelector(state => state.favorites);
    const { goTo, loadGame } = useAsgActions();
    const dispatch = useDispatch();
    const {
        showStripsGridUI,
    } = useSelector((state) => state.app.config);
    const hasFavoritesGames = favoriteGames.length;
    let messageText = null;
    const isFavoritesCategory = areFavoritesEnabled
        && currentSubcategoryAction === verticalActionTypesEnum.FAVORITES_CATEGORY;

    // get live casino data
    useLiveCasinoState(setLiveCasinoData);

    const isShowWinners = showWinners && !isFavoritesCategory && !showStripsGridUI;

    if (isFavoritesCategory) {

        if (hasFavoritesGames) {
            gameIds = favoriteGames;
        }
    }

    const processedGameIds = useApplySubcategoriesActionsToGames(gameIds);

    let { gamesToRender, isMoreGamesBtnVisible, loadMore } = useReadMoreGames({ gameIds: processedGameIds });

    const { amountOfWinnersThumbnails, countColumnsCallback } = useWinnersCalculateHook(
        {
            gamesToRender,
            maxAmountOfWinnersThumbnails,
            containerGridRef
        });

    if (!isFavoritesCategory && (!Array.isArray(processedGameIds) || !processedGameIds.length)) {
        return null;
    }

    if (isFavoritesCategory) {
        const maxGamesInGrid = 50;
        gamesToRender = gamesToRender.slice(0, maxGamesInGrid);
        isMoreGamesBtnVisible = false;

        if (!hasFavoritesGames || !gamesToRender.length) {
            messageText = 'favoritesEmpty';
        }
    }

    const messageClassName = classNames({
        'asg-vertical__message--strips-grid-ui': showStripsGridUI,
    });

    const loadMoreVariant = showStripsGridUI ? 'primary' : undefined;

    return (<>
        <GridMessage messageText={messageText} centerTextMobileResolution={true}
            className={messageClassName} />
        <CasinoGamesGridContainer ref={containerGridRef}>
            {/* winners thumbnails */}
            {isShowWinners && !isMobile && (new Array(amountOfWinnersThumbnails))
                .fill(undefined)
                .map((x, index) => (
                    <GridItem
                        key={index}
                        className="casino-vertical-grid__item--winner"
                    >
                        <WinnersDesktopContainer gridPosition={index} />
                    </GridItem>
                ))}

            {GamesService.renderCasinoThumbnails({
                gamesToRender,
                AsgFW,
                currentVerticalId,
                verticalsById,
                regulation,
                Currency,
                CurrencySign,
                liveCasinoData,
                session,
                isMobile,
                recentGames,
                loadGame,
                goTo,
                buyWin,
                dispatch,
                Dictionary,
                countColumnsCallback,
                jackpots,
                jackpotsByDate: jackpotsByDateEndAsc,
                isFavoritesCategory,
            })}

            {isMoreGamesBtnVisible
                && <LoadMore className="casino-vertical-grid__item--more"
                    clickHandler={loadMore}
                    variant={loadMoreVariant}
                />}
        </CasinoGamesGridContainer>
    </>
    );
};
